import { Card, Text, Title } from '@wyz/ui';
import { isNil } from 'lodash-es';
import * as React from 'react';
import { Trans, useLocale } from '~/common/context';
import type { IContainerOrder } from '~/common/types';

interface SalesSummaryCardProps {
  order: Pick<
    IContainerOrder,
    | 'totalQuantity'
    | 'totalPrice'
    | 'updatedTotalQuantity'
    | 'updatedTotalPrice'
    | 'currency'
  >;
}

export const SalesSummaryCard: React.FC<SalesSummaryCardProps> = ({
  order,
}) => {
  const locale = useLocale();
  const currency = order.currency ?? undefined;

  return (
    <Card className='mb-3'>
      <Card.Body>
        <Title heading='lg' weight='bold' className='mb-3' wrap>
          <Trans i18nKey='app.container.order.detail.sales_summary' />
        </Title>

        <table className='w-100'>
          <thead>
            <tr className='border-bottom'>
              <th className='pb-2'></th>
              <th className='pb-2 text-center'>
                <Text weight='semi-bold' color='secondary-gray'>
                  <Trans i18nKey='app.common.total_quantity' />
                </Text>
              </th>
              <th className='pb-2 text-end'>
                <Text weight='semi-bold' color='secondary-gray'>
                  <Trans i18nKey='app.common.total_price' />
                </Text>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='py-2'>
                <Text weight='semi-bold' color='tertiary-gray'>
                  <Trans i18nKey='app.container.order.detail.initial_order' />
                </Text>
              </td>
              <td className='py-2 text-center'>
                <Text
                  heading='sm'
                  weight='semi-bold'
                  color='secondary'
                  id={`initial-quantity`}
                >
                  {locale.formatters.quantity(order.totalQuantity ?? 0)}
                </Text>
              </td>
              <td className='py-2 text-end'>
                <Text
                  heading='sm'
                  weight='semi-bold'
                  color='secondary'
                  id={`initial-price`}
                >
                  {locale.formatters.money(order.totalPrice ?? 0, { currency })}
                </Text>
              </td>
            </tr>
            <tr>
              <td className='py-2'>
                <Text weight='semi-bold' color='tertiary-gray'>
                  <Trans i18nKey='app.container.order.detail.updated_order' />
                </Text>
              </td>
              <td className='py-2 text-center'>
                <Text
                  heading='sm'
                  weight='semi-bold'
                  color='secondary'
                  id={`updated-quantity`}
                >
                  {isNil(order.updatedTotalQuantity)
                    ? '-'
                    : locale.formatters.quantity(order.updatedTotalQuantity)}
                </Text>
              </td>
              <td className='py-2 text-end'>
                <Text
                  heading='sm'
                  weight='semi-bold'
                  color='secondary'
                  id={`updated-price`}
                >
                  {isNil(order.updatedTotalPrice)
                    ? '-'
                    : locale.formatters.money(order.updatedTotalPrice, {
                        currency,
                      })}
                </Text>
              </td>
            </tr>
          </tbody>
        </table>
      </Card.Body>
    </Card>
  );
};

export default SalesSummaryCard;
